export type BodyType    = '일반'|'천무지체'|'무극지체'|'음양지체'|'극양지체'|'극음지체'|'주화입마'|'내상'
export type MugongStage = '三流'|'二流'|'一流'|'絶頂'|'花境'|'玄境'|'生死境'
export type Element     = '木'|'火'|'土'|'金'|'水'|'氷'|'毒'|'正'|'邪'|'魔'
export type EquipSlot   = 'WEAPON'|'CLOTH'|'HAT'|'GLOVE'|'SHOE'|'CLOAK'|'INNER'|'NECK'|'BRACELET_1'|'BRACELET_2'
export type ItemSlot    = EquipSlot | 'BRACELET'
export type ItemCategory= 'EQUIP'|'CONSUME'|'MUGONG_BOOK'|'MATERIAL'|'HERB'
export type Grade       = 'COMMON'|'UNCOMMON'|'RARE'|'EPIC'|'LEGEND'|'MYTH'
export type SectRole    = '문주'|'장로'|'제자'
export type MugongSlot  = 'SIMBEOP'|'BOBEOP'|'ATTACK'

export interface CharBase {
  userCode:       number
  userName:       string
  bodyType:       BodyType
  bodyStatus:     string
  mugongStage:    MugongStage
  hp:             number
  maxHp:          number
  atk:            number
  def:            number
  speed:          number
  gold:           number
  currentRegion:  string
  totalPower:     number
  turnCount:      number
  lastGlobalTurn: number
  activeAction:   'TRAIN'|'HUNT'|'RECOVER'|null
  activeTarget:   string | null
  activeRegion:   string | null
  lastActionAt:   string | null
  sectId:         number | null
  sectRole:       SectRole | null
}

export interface Item {
  invId:        number
  itemId:       string
  name:         string
  category:     ItemCategory
  slot?:        ItemSlot
  grade:        Grade
  atkBonus:     number
  defBonus:     number
  hpBonus:      number
  speedBonus:   number
  mugongId?:    string
  sellPrice:    number
  qty:          number
  equipSlot?:   EquipSlot
  enhanceLevel: number
  consumeType?: 'HEAL' | 'PERM'
}

export interface Mugong {
  mugongId:     string
  name:         string
  category:     string
  element?:     Element
  grade:        MugongStage
  maxStar:      number
  star:         number
  exp:          number
  activeYn:     boolean
  equippedSlot?: MugongSlot
  sectOnly?:    string
  atkBonus:     number
  defBonus:     number
  hpBonus:      number
  spdBonus:     number
  icon?:        string
}

export interface Sect {
  sectId:      number
  sectName:    string
  leaderCode:  number
  leaderName:  string
  memberCount: number
  description: string | null
  level:       number
  gold:        number
  myRole?:     SectRole
}

export interface Region    { regionId: string; name: string; moveCost: number }
export interface HuntPlace { placeId: string; regionId: string; name: string; minLevel: number }
export interface ActionLog { logId: number; logType: string; result: any; globalTurn: number; at: string }

export interface GameState {
  char:          CharBase
  elements:      Partial<Record<Element, number>>
  categories:    Record<string, number>
  mugongs:       Mugong[]
  inventory:     Item[]
  sect:          Sect | null
  currentRegion: Region
  huntPlaces:    HuntPlace[]
  recentLogs:    ActionLog[]
}

export function initCharBase(userCode: number, userName: string): CharBase {
  return {
    userCode, userName,
    bodyType: '일반', bodyStatus: '정상', mugongStage: '三流',
    hp: 100, maxHp: 100, atk: 10, def: 5, speed: 5,
    gold: 1000, currentRegion: 'RGN_HONAM', totalPower: 0,
    turnCount: 0, lastGlobalTurn: 0,
    activeAction: null, activeTarget: null, activeRegion: null, lastActionAt: null,
    sectId: null, sectRole: null,
  }
}

export function initGameState(userCode: number, userName: string): GameState {
  return {
    char: initCharBase(userCode, userName),
    elements: {}, categories: {}, mugongs: [], inventory: [],
    sect: null,
    currentRegion: { regionId: 'RGN_HONAM', name: '하남', moveCost: 0 },
    huntPlaces: [], recentLogs: [],
  }
}
